<template>
  <div class="d-flex stepper">
    <template v-for="(step, index) in steps">
      <step
        :step="step"
        :key="step.name"
        :index="index"
        :active="index === activeStepIndex"
        :passed="index < activeStepIndex"
        @click.native="$emit('change-step', index)"
      />
      <div
        v-if="index + 1 !== steps.length"
        class="stepper-spacer"
        :class="{'stepper-spacer--active': index < activeStepIndex}"
        :key="index"
      >
        <hr class="d-block d-md-none">
      </div>

    </template>
  </div>
</template>

<script>
import Step from './Step'

export default {
  name: 'Stepper',

  components: {
    Step
  },

  props: {
    steps: {
      type: Array,
      required: true
    },

    activeStepIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss">
.stepper {
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  box-sizing: border-box;

  &-step {
    height: 70px;
    cursor: pointer;
    padding-bottom: 2px;

    @include media-breakpoint-up(lg) {
      border-bottom: 1px solid $border-color;
    }

    &__title {
      display: none;
      @include media-breakpoint-up(md) {
        display: block;
      }
    }

    &__icon {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 2px solid $border-color;
      font-size: 12px;

      // if passed and !valid show box

      &--valid {
        background: #0083a1;
        .valid-step {
          width: 10px;
          height: 10px;
          font-size: 0.5rem;
          border-radius: 50%;
          color: white;
          background: transparent;
        }
      }

      &--invalid {
        background: transparent;
        border: none;
      }

      &--error {
        border: none;
        .i {
          font-size: 1rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }

    &--active,
    &--passed {
      border-bottom: 2px solid #0083a1;
      padding-bottom: 0px;
      .stepper-step__icon {
        border-color: #0083a1;
      }

      @include media-breakpoint-down(md) {

        border: 0;
      }
    }

    @include media-breakpoint-down(md) {
      height: auto;
      font-size: 12px;

      &__icon {
        margin: 0 .5rem 0 0;
      }
    }
  }

  .stepper-spacer {
    flex: 1;
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    @include media-breakpoint-up(lg) {
      border-bottom: 1px solid $border-color;
    }

    hr {
      width: 100%;
    }

    &--active {
      border-bottom: 2px solid #0083a1;
      @include media-breakpoint-down(md) {
        border: 0;
        hr {
          border-color: #00778f;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    height: 1.5rem;
    justify-content: center;
    border: 0;
  }
}
</style>
